var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "c-search-box",
        { on: { enter: _vm.getList } },
        [
          _c("template", { slot: "search" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
              [
                _c("c-select", {
                  attrs: {
                    type: "search",
                    codeGroupCd: "REGUL_ITEM_NATION_CD",
                    itemText: "codeName",
                    itemValue: "code",
                    name: "regulItemNationCd",
                    label: "국가",
                  },
                  model: {
                    value: _vm.searchParam.regulItemNationCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "regulItemNationCd", $$v)
                    },
                    expression: "searchParam.regulItemNationCd",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c(
        "c-table",
        {
          ref: "table",
          attrs: {
            title: "국가별 담당자 목록",
            columns: _vm.grid.columns,
            data: _vm.grid.data,
            checkClickFlag: false,
          },
          scopedSlots: _vm._u([
            {
              key: "customArea",
              fn: function ({ props, col }) {
                return [
                  col.name === "users"
                    ? [
                        _c("c-tag", {
                          attrs: {
                            editable: _vm.editable,
                            icon: "person_outline",
                            itemText: "userName",
                            itemValue: "check",
                            name: "users",
                          },
                          on: {
                            addTag: function ($event) {
                              return _vm.addManager(props.row)
                            },
                            removeTag: (item) => _vm.removeManager(item),
                          },
                          model: {
                            value: props.row.users,
                            callback: function ($$v) {
                              _vm.$set(props.row, "users", $$v)
                            },
                            expression: "props.row.users",
                          },
                        }),
                      ]
                    : _vm._e(),
                ]
              },
            },
          ]),
        },
        [
          _c("template", { slot: "table-button" }, [
            _c(
              "div",
              [
                _c(
                  "q-btn-group",
                  { attrs: { outline: "" } },
                  [
                    _c("c-btn", {
                      attrs: { label: "검색", icon: "search" },
                      on: { btnClicked: _vm.getList },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }